export default {
  gradient01: "linear-gradient(90deg, #92FE9D 0%, #00C9FF 100%)",
  gradient02: "linear-gradient(90deg, #16D9E3 0%, #30C7EC 47%, #46AEF7 100%)",
};
